import React, { useState, useEffect } from 'react';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import { useHistory } from 'react-router-dom';
import { filterPanelList } from '../Controller/HomeController';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { loaderStateTrue, loaderStateFalse, userSearchData, userSearchDataError } from '../../../../../src/Actions/AllAction';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import SkeletonThemeContentGroupList from '../../../../Utility/Components/SkeletonThemeContentGroupList';
import Utility from '../../../../Utility/Utility'
function PropertyTypeList(props) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const history = useHistory();
    const [propertyTypeData, setPropertyTypeData] = useState([])
    const [apiCallFinish, setApiCallFinish] = useState(false)
    const totalPages = Math.ceil(propertyTypeData.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = propertyTypeData.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        getGroupTour();
    }, []);

    const getGroupTour = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let filters = {};
        let globalQueryParamshash = {};
        if (Object.keys(globalQueryParamshash).length > 0) {
            filters['filters'] = JSON.stringify(globalQueryParamshash);
        }

        filterPanelList(filters)
            .then((response) => {
                if (response.success) {
                    if (Object.keys(response.data).length > 0 && response.data.hasOwnProperty('property_type') && response.data.property_type.length > 0) {
                        setPropertyTypeData(response.data.property_type);
                    } else {
                        setPropertyTypeData([]);
                    }
                }
                setApiCallFinish(true); // ✅ Move here
            })
            .catch((error) => {
                console.error("API Error:", error);
                setApiCallFinish(true); // ✅ Even on error, mark API as completed
            });
    };

    const chooseHomeOrGuestHouse = (type) => {
        if (props.userSearchDataFromReducer && props.userSearchDataFromReducer.hasOwnProperty('destination') && props.userSearchDataFromReducer.destination && props.userSearchDataFromReducer.destination != "") {
            let reducerData = props.userSearchDataFromReducer;
            let filterPanelData = reducerData.filterData;
            filterPanelData = { ...filterPanelData, 'property_type': type };
            let tempSearchData = { ...reducerData, ["filterData"]: filterPanelData }
            props.userSearchData(tempSearchData)
            props.history.push(`/${localStorage.getItem('i18nextLng')}/search`);
        } else {
            /* Utility.toastNotifications(`First, choose your destination on the homepage, then select the type of property.`, "Warning", "warning");
             let tempSearchDataError = props.userSearchErrorDataFromReducer ? props.userSearchErrorDataFromReducer : {}
             tempSearchDataError = { ...tempSearchDataError, 'destination': "Required field" }
             props.userSearchDataError(tempSearchDataError);*/
            let reducerData = props.userSearchDataFromReducer;
            let filterPanelData = reducerData.filterData;
            filterPanelData = { ...filterPanelData, 'property_type': type };
            let tempSearchData = { ...reducerData, ["filterData"]: filterPanelData }
            props.userSearchData(tempSearchData)
            props.history.push(`/${localStorage.getItem('i18nextLng')}/search`);
        }
    }


    return (
        <div className="tourList-page hotel-details sliderExplore groupTour propertyTypeContainer">
            <div className="container">
                {apiCallFinish ?
                    <div className="groupTour-List-box">
                        <h2 className="sectionTitle">Browse by property type</h2>
                        <p className="sectionDec">There are {propertyTypeData.length} types of property</p>
                        <div className="groupTour-List-box-inner">
                            <div className="row">
                                {currentItems.map((item, index) => {
                                    let imageUrl = '';
                                    imageUrl = item?.property_image || '';

                                    return (
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-auto" key={index}>
                                            <div className="item">
                                                <div className="caro_Itm_Explore">
                                                    <div className='innCaro_Itm_Explore' onClick={() => chooseHomeOrGuestHouse(item.name)}>
                                                        <div className="pic_Explore">
                                                            <div className="pic_Inn_Explore">
                                                                <LazyImage
                                                                    src={imageUrl || require('../../../../Utility/Public/images/stateLoaderImage.png')}
                                                                    loaderImage={require('../../../../Utility/Public/images/stateLoaderImage.png')}
                                                                />
                                                                <div className="overlay">
                                                                    <div className="overlayText">
                                                                        <img className="plusIcon" src={require('../../../../Utility/Public/images/pls.png')} alt="Plus icon" />
                                                                        View Details
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="text_Explore">
                                                            {item.name && item.name.length > 35 ? (
                                                                <OverlayTrigger overlay={<Tooltip>{item.name}</Tooltip>}>
                                                                    <h3 className='roomTypeName'>{item.name.substring(0, 35) + "..."}</h3>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                <h3>{item.name}</h3>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {propertyTypeData.length > itemsPerPage && (
                                <div className="pagination-controls mt-3 mb-3 text-center">
                                    <button
                                        className="page-btn mx-1"
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>

                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentPage(index + 1)}
                                            className={`page-btn mx-1 ${currentPage === index + 1 ? 'active' : ''}`}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}

                                    <button
                                        className="page-btn mx-1"
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>


                    </div>
                    :
                    <SkeletonThemeContentGroupList />
                }
            </div>
        </div>
    );
}

PropertyTypeList.defaultProps = {

}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
        userSearchErrorDataFromReducer: globalState.mainReducerData.userSearchDataError,

    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, userSearchData, userSearchDataError, })(withNamespaces()(PropertyTypeList));
